/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Reports_Pdf_PageInputs */

const en_reports_pdf_page = /** @type {(inputs: Reports_Pdf_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const pt_br2_reports_pdf_page = /** @type {(inputs: Reports_Pdf_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Reports_Pdf_PageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_pdf_page = /** @type {((inputs: Reports_Pdf_PageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Pdf_PageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_pdf_page(inputs)
	return pt_br2_reports_pdf_page(inputs)
});